<template>
    <el-card>
        <component-server @gameValue="getGameValue"></component-server>
        <component-query :queryMode="playerQueryMode" @usersData="getUsersData"></component-query>
        <!-- 查询用户数据 -->
        <!-- id,email,nick,level,status -->
        <el-table :data="players" border style="margin-top:20px;width: 100%">
            <el-table-column prop="id" label="用户id" width="120"></el-table-column>
            <el-table-column prop="server" label="游戏服编号" width="120"></el-table-column>
            <el-table-column prop="email" label="sid" width="120"></el-table-column>
            <el-table-column prop="channel" label="渠道" width="120"></el-table-column>
            <el-table-column prop="nick" label="昵称" width="120"></el-table-column>
            <el-table-column prop="level" label="等级" width="50"></el-table-column>
            <el-table-column label="禁言/伪禁言状态(截止时间)" width="180">
                <template slot-scope="scope">
                    <span v-if="scope.row.silence == 0">正常</span>
                    <span v-if="scope.row.silence == 1">{{(scope.row.silenceEnd == -1)?'永久禁言':((scope.row.silenceEnd < new Date().getTime())?'正常':'禁言(' + Utils.formatDate(new Date(scope.row.silenceEnd)) + ')')}}</span>
                    <span v-if="scope.row.silence == 2">{{(scope.row.silenceEnd == -1)?'永久禁言':((scope.row.silenceEnd < new Date().getTime())?'正常':'伪禁言(' + Utils.formatDate(new Date(scope.row.silenceEnd)) + ')')}}</span>
                </template>
            </el-table-column>
            <el-table-column label="封停状态(截止时间)" width="180">
                <template slot-scope="scope">
                    <span v-if="scope.row.block == 0">正常</span>
                    <span v-if="scope.row.block == 1">{{(scope.row.blockEnd == -1)?'永久封停':((scope.row.blockEnd < new Date().getTime())?'正常':'后台封禁(' + Utils.formatDate(new Date(scope.row.blockEnd)) + ')')}}</span>
                    <span v-if="scope.row.block == 2">{{(scope.row.blockEnd == -1)?'永久封停':((scope.row.blockEnd < new Date().getTime())?'正常':'系统封禁(' + Utils.formatDate(new Date(scope.row.blockEnd)) + ')')}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="infoShield" label="屏蔽状态" width="50">
                <template slot-scope="scope">
                    <span v-if="scope.row.infoShield == 0">正常</span>
                    <span v-if="scope.row.infoShield == 1">屏蔽</span>
                </template>
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button class="player-btn" type="success" @click="showUserDetail(scope.row)">查看详细数据</el-button>
                    <el-button class="player-btn" type="primary" @click="removeBanShow('block',scope.row)">解封角色</el-button>
                    <el-button class="player-btn" type="primary" @click="blockAndForbidShow('block',scope.row)">封停角色</el-button>
                    <el-button class="player-btn" type="primary" @click="removeBanShow('forbid',scope.row)">解除禁言
                        <el-tooltip class="item" effect="dark" placement="top-start">
                            <div slot="content">
                                （包含解除禁言和伪禁言）
                            </div>
                            <i class="el-icon-info"></i>
                        </el-tooltip>
                    </el-button>
                    <el-button class="player-btn" type="primary" @click="blockAndForbidShow('forbid',scope.row)">角色禁言</el-button>
                    <el-button class="player-btn" type="primary" @click="blockAndForbidShow('fakeForbid',scope.row)">角色伪禁言
                        <el-tooltip class="item" effect="dark" placement="top-start">
                            <div slot="content">
                                （玩家发言内容仅自己可见，不会推送给别人）
                            </div>
                            <i class="el-icon-info"></i>
                        </el-tooltip>
                    </el-button>
                    <el-button class="player-btn" type="primary" @click="renameShow(scope.row)">修改角色名</el-button>
                    <el-button class="player-btn" type="primary" @click="deductItemShow(scope.row)">道具扣减</el-button>
                    <el-button class="player-btn" type="primary" @click="playerDisconnect(scope.row)" v-if="globalConfig.playerDisconnectSwitch == 1">解除关联</el-button>
                    <el-button class="player-btn" type="primary" @click="playerInfoShield(scope.row,'1')" v-if="scope.row.infoShield == 0">屏蔽玩家信息</el-button>
                    <el-button class="player-btn" type="primary" @click="playerInfoShield(scope.row,'0')" v-if="scope.row.infoShield == 1">解除玩家屏蔽</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog :title='"id:"+player.user.id +"-昵称:"+player.user.nick + "的数据"' :visible.sync="previewDateShow" width="75%"
            lock-scroll center>
            <el-tabs tab-position="left" style="height: 100%;" @tab-click="handleClick" v-model="activeName">
                <el-tab-pane name="basic" label="基础数据">
                    <el-card>
                        <div slot="header" class="clearfix">
                            <span>基础信息</span>
                            <el-button type="primary" icon="el-icon-document-copy" @click="handleCopyInfo(player)" v-clipboard:copy="copyInfo" v-clipboard:success="onCopy"
                                       v-clipboard:error="onError"></el-button>
                        </div>
                        <el-form label-position="left" :inline="true" label-suffix=":" size="mini" class="player-form">
                            <el-row>
                                <el-col :span="7">
                                    <el-form-item label="id">
                                        {{player.user.id}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="7">
                                    <el-divider direction="vertical"></el-divider>
                                    <el-form-item label="昵称">
                                        {{player.user.nick}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="7">
                                    <el-divider direction="vertical"></el-divider>
                                    <el-form-item label="sid">
                                        {{player.user.email}}
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="7">
                                    <el-form-item label="探索者等级">
                                        {{player.user.level}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="7">
                                    <el-divider direction="vertical"></el-divider>
                                    <el-form-item label="回响等级">
                                        {{player.user.resoundLevel}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="7">
                                    <el-divider direction="vertical"></el-divider>
                                    <el-form-item label="当前战力">
                                        {{player.user.currentBattleE}}
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="7">
                                    <el-form-item label="连续登录次数">
                                        {{player.user.loginInARow}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="10">
                                    <el-divider direction="vertical"></el-divider>
                                    <el-form-item label="最近登录时间">
                                        {{player.user.loginModified}}
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="7">
                                    <el-form-item label="充值金额(Android)">
                                        {{player.user.charged}}
                                        <span class="charged-points">{{player.user.charged>0?'(分)':''}}</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="7">
                                    <el-divider direction="vertical"></el-divider>
                                    <el-form-item label="充值金额(iOS)">
                                        {{player.user.chargedIos}}
                                        <span class="charged-points">{{player.user.chargedIos>0?'(分)':''}}</span>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="7">
                                    <el-form-item label="总消费(不含代金券)">
                                        {{player.user.chargedTotal}}
                                        <span class="charged-points">{{player.user.chargedTotal>0?'(分)':''}}</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="7">
                                    <el-divider direction="vertical"></el-divider>
                                    <el-form-item label="总消费(含代金券)">
                                        {{player.user.chargedTotalAll}}
                                        <span class="charged-points">{{player.user.chargedTotalAll>0?'(分)':''}}</span>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="禁言/伪禁言状态(截止时间)">
                                        <span v-if="player.user.silence == 0">正常</span>
                                        <span v-if="player.user.silence == 1">{{(player.user.silenceEnd == -1)?'永久禁言':((player.user.silenceEnd < new Date().getTime())?'正常':'禁言(' + Utils.formatDate(new Date(player.user.silenceEnd)) + ')')}}</span>
                                        <span v-if="player.user.silence == 2">{{(player.user.silenceEnd == -1)?'永久禁言':((player.user.silenceEnd < new Date().getTime())?'正常':'伪禁言(' + Utils.formatDate(new Date(player.user.silenceEnd)) + ')')}}</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-divider direction="vertical"></el-divider>
                                    <el-form-item label="封停状态(截止时间)">
                                        <span v-if="player.user.block == 0">正常</span>
                                        <span v-if="player.user.block == 1">{{(player.user.blockEnd == -1)?'永久封停':((player.user.blockEnd < new Date().getTime())?'正常':'后台封禁(' + Utils.formatDate(new Date(player.user.blockEnd)) + ')')}}</span>
                                        <span v-if="player.user.block == 2">{{(player.user.blockEnd == -1)?'永久封停':((player.user.blockEnd < new Date().getTime())?'正常':'系统封禁(' + Utils.formatDate(new Date(player.user.blockEnd)) + ')')}}</span>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </el-card>
                    <!--<el-card>-->
                        <!--<div slot="header" class="clearfix">-->
                            <!--<span>操作</span>-->
                        <!--</div>-->
                        <!--<div class="data-btn-group">-->
                            <!--<el-button type="primary">解除封停</el-button>-->
                            <!--<el-button type="primary">封停账号</el-button>-->
                        <!--</div>-->
                        <!--<div class="data-btn-group">-->
                            <!--<el-button type="primary">解除禁言-->
                                <!--<el-tooltip class="item" effect="dark" placement="top-start">-->
                                    <!--<div slot="content">-->
                                        <!--（包含解除禁言和伪禁言）-->
                                    <!--</div>-->
                                    <!--<i class="el-icon-info"></i>-->
                                <!--</el-tooltip>-->
                            <!--</el-button>-->
                            <!--<el-button type="primary">角色禁言</el-button>-->
                            <!--<el-button type="primary">角色伪禁言-->
                                <!--<el-tooltip class="item" effect="dark" placement="top-start">-->
                                    <!--<div slot="content">-->
                                        <!--（玩家发言内容仅自己可见，不会推送给别人）-->
                                    <!--</div>-->
                                    <!--<i class="el-icon-info"></i>-->
                                <!--</el-tooltip>-->
                            <!--</el-button>-->
                        <!--</div>-->
                        <!--<div class="data-btn-group">-->
                            <!--<el-button type="primary">修改角色名</el-button>-->
                        <!--</div>-->
                    <!--</el-card>-->

                    <!--历史记录-->
                    <!-- 神灵 -->
                    <!-- 神灵契约 -->
                    <!-- 好友 -->
                    <!-- 好友请求 -->
                    <!-- 社交好友 -->
                    <!-- 强敌 -->
                </el-tab-pane>
                <el-tab-pane name="monsters" label="怪兽数据">
                    <el-card>
                        <div slot="header" class="clearfix">
                            <div style="margin-bottom: 10px;">怪兽查询</div>
                            <div style="display: flex;justify-content: space-between;align-items: center;">
                                <div>
                                    {{monsterQueryForm.identifier?('怪兽编号:'+ monsterQueryForm.identifier):''}}
                                    {{monsterQueryForm.lv2?('等级范围:'+ monsterQueryForm.lv1 + '-' + monsterQueryForm.lv2):''}}
                                    {{dateTime?('等级范围:'+ dateTime[0] + '至' + dateTime[1]):''}}
                                </div>
                                <div>
                                    <el-select v-model="monsterConditions" filterable clearable default-first-option
                                               :placeholder='$t("reward_editor.2")' @change="findMonsterByConditions">
                                        <el-option v-for="(item,index) in selectedMonsterConditionData" :key="index" :label="(item.identifier?'编号:':'') + item.identifier +' ' + (item.lv2?'等级:':'') + item.lv1 + '-' + item.lv2 + ' ' + (item.dateTime2?'时间:':'') + item.dateTime1 + (item.dateTime2?'-':'') + item.dateTime2"
                                                   :value="index">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>
                        <el-form label-suffix=":">
                            <el-form-item label="怪兽编号">
                                <el-select v-model="monsterQueryForm.identifier" filterable clearable default-first-option
                                    :placeholder='$t("reward_editor.2")'>
                                    <el-option v-for="item in monsterConfigs" :key="item.id" :label="item.id +'-' + $t(item.name)"
                                        :value="item.id">
                                        <el-image style="width: 30px; height: 30px; float: left" :src="'./static/monster_icon/'+item.id+'.png'"
                                            fit="cover"></el-image>
                                        <span style="float: right">{{ $t(item.name) }}</span>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="等级范围">
                                <el-input-number v-model="monsterQueryForm.lv1" :min="1" :max="999" placeholder="最小等级"></el-input-number>
                                至
                                <el-input-number v-model="monsterQueryForm.lv2" :min="1" :max="999" placeholder="最小等级"></el-input-number>
                            </el-form-item>
                            <el-form-item label="获得时间">
                                <el-date-picker v-model="dateTime" type="daterange" range-separator='至'
                                    start-placeholder='起始时间' end-placeholder='结束时间' value-format="yyyy-MM-dd">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="">
                                <el-button type="primary" @click="selectMonsters">查询</el-button>
                            </el-form-item>
                        </el-form>
                    </el-card>

                    <el-table :data="selectMonsterData" border  style="margin-top:20px;width: 100%">
                        <el-table-column type="expand">
                            <template slot-scope="props">
                                <el-form label-position="left" inline class="demo-table-expand ">
                                    <el-card>
                                        <div slot="header" class="clearfix">
                                            <span>基础数据</span>
                                        </div>
                                        <el-row>
                                            <el-col :span="5">
                                                <el-form-item label="昵称:">
                                                    {{props.row.nick}}
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="5">
                                                <el-form-item label="是否可用:">
                                                    {{props.row.enabled?'可用':'禁用'}}
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="5">
                                                <el-form-item label="是否锁定:">
                                                    {{props.row.locked?'锁定':'无锁'}}
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-card>
                                    <el-card>
                                        <div slot="header" class="clearfix">
                                            <span>养成数据</span>
                                        </div>
                                        <el-row>
                                            <el-col :span="5">
                                                <el-form-item label="穿着的皮肤:">
                                                    {{props.row.skinId}}
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="5">
                                                <el-form-item label="领域副本-已解锁最高难度:">
                                                    {{props.row.realmType}}
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="8">
                                                <el-form-item label="技能星级:">
                                                    {{props.row.abilityStar}}
                                                </el-form-item>
                                            </el-col>
                                        </el-row>

                                        <el-row>
                                            <el-col :span="5">
                                                <el-form-item label="性格id:">
                                                    {{props.row.temperamentId}}
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="5">
                                                <el-form-item label="性格点数:">
                                                    {{props.row.temperamentPoint}}
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="8">
                                                <el-form-item label="性格各项数据最高战绩:">
                                                    {{props.row.temperamentBest}}
                                                </el-form-item>
                                            </el-col>
                                        </el-row>

                                        <el-row>
                                            <el-col :span="5">
                                                <el-form-item label="强化次数:">
                                                    {{props.row.strengthenCount}}
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="5">
                                                <el-form-item label="强化数据:">
                                                    {{props.row.strengthen}}
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-card>
                                    <el-card>
                                        <div slot="header" class="clearfix">
                                            <span>极化数据</span>
                                        </div>
                                        <el-row>
                                            <el-col :span="5">
                                                <el-form-item label="极化攻击力:">
                                                    {{props.row.plrzAtk}}
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="5">
                                                <el-form-item label="极化体力:">
                                                    {{props.row.plrzCon}}
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="5">
                                                <el-form-item label="极化霸气:">
                                                    {{props.row.plrzHaki}}
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="5">
                                                <el-form-item label="极化速度:">
                                                    {{props.row.plrzMspd}}
                                                </el-form-item>
                                            </el-col>
                                        </el-row>

                                        <el-row>
                                            <el-col :span="5">
                                                <el-form-item label="极化能力数据:">
                                                    {{props.row.plrzAbilities}}
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="5">
                                                <el-form-item label="极化重组临时数据:">
                                                    {{props.row.plrzTemp}}
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-card>
                                </el-form>
                            </template>
                        </el-table-column>
                        <el-table-column prop="id" label="id"></el-table-column>
                        <el-table-column prop="identifier" label="编号" sortable></el-table-column>
                        <el-table-column label="怪兽名称">
                            <template slot-scope="scope">
                                <span v-for="item in monsterConfigs" :key="item.id" v-if="item.id == scope.row.identifier">
                                    {{ $t(item.name) }}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column label="怪兽图标">
                            <template slot-scope="scope">
                                <el-image style="width: 60px; height: 60px"
                                          :src="'./static/monster_icon/'+scope.row.identifier+'.png'"
                                          fit="cover">

                                </el-image>
                            </template>
                        </el-table-column>
                        <el-table-column prop="battleE" label="战力" sortable></el-table-column>
                        <el-table-column prop="level" label="等级" sortable></el-table-column>
                        <el-table-column prop="evolutionCount" label="进化次数" sortable></el-table-column>
                        <el-table-column prop="gmtCreate" label="获得时间" :formatter="formatterTime"></el-table-column>
                    </el-table>

                </el-tab-pane>
                <el-tab-pane name="skins" label="皮肤数据">
                    <el-card>
                        <div slot="header" class="clearfix">
                            <span>怪兽皮肤</span>
                        </div>
                        <el-form label-suffix=":" label-position="left">
                            <el-form-item label="怪兽编号">
                                <el-select v-model="skinQueryForm.identifier" filterable default-first-option
                                    :placeholder='$t("reward_editor.2")'>
                                    <el-option v-for="item in monsterConfigs" :key="item.id" :label="item.id +'-' + $t(item.name)"
                                        :value="item.id">
                                        <el-image style="width: 30px; height: 30px; float: left" :src="'./static/monster_icon/'+item.id+'.png'"
                                            fit="cover"></el-image>
                                        <span style="float: right">{{ $t(item.name) }}</span>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="皮肤类型">
                                <el-select v-model="skinQueryForm.type">
                                    <el-option :key="index" v-for="(sgt,index) in skinType" :label="sgt.val" :value="sgt.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="">
                                <el-button type="primary">查询</el-button>
                                <el-button type="success">补偿皮肤</el-button>
                            </el-form-item>
                        </el-form>
                    </el-card>

                    <el-table :data="player.skin" border  style="margin-top:20px;width: 100%">
                        <el-table-column prop="id" label="皮肤编号"></el-table-column>
                        <el-table-column prop="identifier" label="怪兽编号"></el-table-column>
                        <el-table-column prop="isTimeLimit" label="是否限时皮肤"></el-table-column>
                        <el-table-column prop="timeLimit" label="到期时间"></el-table-column>
                        <el-table-column label="操作">
                            <template>
                                <el-button type="danger">禁用</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
                <el-tab-pane name="emblems" label="元核数据">
                    <el-card>
                        <div slot="header" class="clearfix">
                            <div style="margin-bottom: 10px;">元核数据</div>
                            <div style="display: flex;justify-content: space-between;align-items: center;">
                                <div>
                                    {{emblemQueryForm.quality?('元核品质:'+ emblemQueryForm.quality):''}}
                                    {{emblemQueryForm.lv2?('等级范围:'+ emblemQueryForm.lv1 + '-' + emblemQueryForm.lv2):''}}
                                </div>
                                <div>
                                    <el-select v-model="emblemConditions" filterable clearable default-first-option
                                               :placeholder='$t("reward_editor.2")' @change="findEmblemByConditions">
                                        <el-option v-for="(item,index) in selectedEmblemConditionData" :key="index" :label="(item.quality?'品质:':'') + item.quality +' ' + (item.lv2?'等级:':'') + item.lv1 + '-' + item.lv2"
                                                   :value="index">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>
                        <el-form label-suffix=":" label-position="left">
                            <el-form-item label="品质">
                                <el-select v-model="emblemQueryForm.quality" filterable clearable default-first-option :placeholder='$t("reward_editor.2")'
                                    value="">
                                    <el-option v-for="item in emblemQuality" :key="item.id" :label="item.val" :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="等级范围">
                                <el-input-number v-model="emblemQueryForm.lv1" :min="1" :max="200" ></el-input-number>
                                <el-input-number v-model="emblemQueryForm.lv2" :min="1" :max="200" ></el-input-number>
                            </el-form-item>
                            <el-form-item label="">
                                <el-button type="primary" @click="selectEmblems">查询</el-button>
                            </el-form-item>
                        </el-form>
                    </el-card>

                    <el-table :data="selectEmblemData" border  style="margin-top:20px;width: 100%">
                        <el-table-column type="expand">
                            <template slot-scope="props">
                                <el-form label-position="left" inline class="demo-table-expand">
                                    <el-table :data="props.row.properties">
                                        <el-table-column prop="id" label="id"></el-table-column>
                                        <el-table-column  label="类型">
                                            <template slot-scope="prop">
                                                <span v-if="prop.row.type==0">
                                                    主属性
                                                </span>
                                                <span v-if="prop.row.type==1">
                                                    两字词条
                                                </span>
                                                <span v-if="prop.row.type==2">
                                                    四字词条
                                                </span>
                                                <span v-if="prop.row.type==3">
                                                    宿命
                                                </span>
                                            </template>
                                        </el-table-column>

                                        <el-table-column label="属性效果">
                                            <template slot-scope="scope">
                                                {{$t(emblemEffectConfigMap[scope.row.effectId].name)}}
                                            </template>

                                        </el-table-column>
                                        <el-table-column label="品质">
                                            <template slot-scope="scope">
                                                {{emblemQualityMap[scope.row.quality]}}
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="rdFloat" label="随机浮动系数"></el-table-column>
                                    </el-table>
                                </el-form>
                            </template>
                        </el-table-column>
                        <el-table-column prop="id" label="id"></el-table-column>
                        <el-table-column label="名称">
                            <template slot-scope="scope">
                                <span v-for="item in scope.row.properties" :key="item.id" v-if="item.type == 3">
                                     {{$t(emblemEffectConfigMap[item.effectId].name)}}-
                                </span>
                                <span v-for="item in scope.row.properties" :key="item.id" v-if="item.type == 0">
                                     {{$t(emblemEffectConfigMap[item.effectId].name)}}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column label="图标">
                            <template slot-scope="scope">
                                <el-image v-if="scope.row.baseType > 0" style="width: 60px; height: 60px"
                                          :src="'./static/glyph_icon/'+scope.row.quality+'_'+scope.row.baseType+'.png'"
                                          fit="cover">
                                </el-image>
                            </template>
                        </el-table-column>
                        <el-table-column  label="品质">
                        <template slot-scope="scope">
                            {{emblemQualityMap[scope.row.quality]}}
                        </template>
                        </el-table-column>
                        <el-table-column label="等级(阶段)">
                            <template slot-scope="scope">
                                {{scope.row.level}}（{{scope.row.stage}}）
                            </template>
                        </el-table-column>
                        <el-table-column prop="synchronizeLevel" label="同调等级"></el-table-column>

                        <el-table-column label="是否已鉴定">
                            <template slot-scope="scope">
                                <span v-if="scope.row.identified==true">
                                    已鉴定
                                </span>
                                <span v-if="scope.row.identified==false">
                                    未鉴定
                                </span>
                            </template>

                        </el-table-column>

                        <!--<el-table-column label="操作">-->
                            <!--<template>-->
                                <!--<el-button type="danger">禁用</el-button>-->
                            <!--</template>-->
                        <!--</el-table-column>-->
                    </el-table>
                </el-tab-pane>
                <!--<el-tab-pane name="lineups" label="阵容数据">-->
                    <!--<el-card>-->
                        <!--<div slot="header" class="clearfix">-->
                            <!--<span>阵容数据</span>-->
                        <!--</div>-->
                        <!--<el-form label-suffix=":" label-position="left">-->
                            <!--<el-form-item label="阵容编号">-->
                                <!--<el-select v-model="lineupNo" filterable default-first-option-->
                                           <!--placeholder='选择阵容编号'>-->
                                    <!--<el-option v-for="item in lineupNoType" :key="item.id" :label="item.id +'-' + item.val"-->
                                               <!--:value="item.id">-->
                                    <!--</el-option>-->
                                <!--</el-select>-->
                            <!--</el-form-item>-->
                            <!--<el-form-item label="">-->
                                <!--<el-button type="primary" @click="selectLineups">查询</el-button>-->
                            <!--</el-form-item>-->
                        <!--</el-form>-->
                    <!--</el-card>-->

                    <!--<el-table :data="lineups">-->
                        <!--<el-table-column prop="lineupNo" label="阵容编号"></el-table-column>-->
                        <!--<el-table-column prop="battleE" label="战力"></el-table-column>-->

                    <!--</el-table>-->
                <!--</el-tab-pane>-->
                <el-tab-pane name="warGroove" label="战纹数据">
                    <el-card>
                        <div slot="header" class="clearfix">
                            <div style="margin-bottom: 10px;">战纹数据</div>
                            <div style="display: flex;justify-content: space-between;align-items: center;">
                                <div>
                                    {{warGrooveQueryForm.quality?('战纹品质:'+ warGrooveQualityMap[warGrooveQueryForm.quality]):''}}
                                </div>
                                <div>
                                    <el-select v-model="warGrooveConditions" filterable clearable default-first-option
                                               :placeholder='$t("reward_editor.2")' @change="findWarGrooveByConditions">
                                        <el-option v-for="(item,index) in selectedWarGrooveConditionData" :key="index" :label="(item.quality!==''?'品质:':'') + warGrooveQualityMap[item.quality]"
                                                   :value="index">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>
                        <el-form label-suffix=":" label-position="left">
                            <el-form-item label="品质">
                                <el-select v-model="warGrooveQueryForm.quality" filterable default-first-option
                                           :placeholder='$t("reward_editor.2")'>
                                    <el-option v-for="item in warGrooveQuality" :key="item.id" :label="item.val"
                                               :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="">
                                <el-button type="primary" @click="selectWarGroove">查询</el-button>
                            </el-form-item>
                        </el-form>
                    </el-card>

                    <el-table :data="selectWarGrooveData">
                        <el-table-column prop="id" label="id"></el-table-column>
                        <el-table-column prop="identifier" label="编号"></el-table-column>
                        <el-table-column label="图标">
                            <template slot-scope="scope">
                                <span>{{$t('warGrooveConfigName_' + scope.row.identifier)}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="quality" label="品质">
                            <template slot-scope="scope">
                                {{warGrooveQualityMap[scope.row.quality]}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="pipeline" label="通道"></el-table-column>
                        <el-table-column prop="fillFlag" label="镶嵌标记"></el-table-column>
                    </el-table>

                </el-tab-pane>
                <el-tab-pane name="props" label="物品数据">
                    <el-card>
                        <div slot="header" class="clearfix">
                            <div style="margin-bottom: 10px;">物品数据</div>
                            <div style="display: flex;justify-content: space-between;align-items: center;">
                                <div>
                                    {{propQueryForm.identifier?('物品编号:'+ propQueryForm.identifier):''}}
                                    {{propQueryForm.type?('物品大类:'+ propOptionMap[propQueryForm.type]):''}}
                                </div>
                                <div>
                                    <el-select v-model="propConditions" filterable clearable default-first-option
                                               :placeholder='$t("reward_editor.2")' @change="findPropByConditions">
                                        <el-option v-for="(item,index) in selectedPropConditionData" :key="index" :label="(item.identifier!==''?'物品编号:':'') + item.identifier + ' ' + (item.type!==''?'物品大类:':'') + propOptionMap[item.type]"
                                                   :value="index">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>
                        <el-form label-suffix=":" label-position="left">
                            <el-form-item label="物品编号">
                                <el-select v-model="propQueryForm.identifier" filterable clearable default-first-option
                                           :placeholder='$t("reward_editor.2")'>
                                    <el-option v-for="item in allPropData" :key="item.id" :label="item.id +'-' + item.name"
                                               :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="物品大类">
                                <el-select v-model="propQueryForm.type" filterable clearable default-first-option
                                           :placeholder='$t("reward_editor.2")'>
                                    <el-option v-for="(key,value) in propOptionMap" :key="key" :label="key"
                                               :value="value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="">
                                <el-button type="primary" @click="selectProp">查询</el-button>
                            </el-form-item>
                        </el-form>
                    </el-card>

                    <el-table :data="selectPropData">
                        <el-table-column prop="identifier" label="编号"></el-table-column>
                        <el-table-column label="名称">
                            <template slot-scope="scope">
                                <span v-for="item in propConfigs" :key="item.id" v-if="item.id == scope.row.identifier">
                                    {{$t(item.name)}}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column label="图标">
                            <template slot-scope="scope">
                                <el-image style="width: 60px; height: 60px"
                                          :src="'./static/item_icon/'+scope.row.identifier+'.png'"
                                          fit="cover">
                                    <div slot="error" class="image-slot">
                                        <el-image style="width: 60px; height: 60px"
                                                  :src="'./static/item_icon/0.png'"
                                                  fit="cover">
                                        </el-image>
                                    </div>
                                </el-image>
                            </template>
                        </el-table-column>
                        <el-table-column prop="type" label="大类">
                            <template slot-scope="scope">
                                {{propOptionMap[scope.row.type]}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="amount" label="数量"></el-table-column>
                        <el-table-column prop="buyTimes" label="购买次数"></el-table-column>
                        <el-table-column prop="gmtModified" label="上次修改时间"></el-table-column>
                        <el-table-column prop="lastRecoveryModified" label="最近一次回复时间"></el-table-column>
                    </el-table>

                </el-tab-pane>
                <el-tab-pane name="mainCity" label="建筑数据">
                    <el-card>
                        <div slot="header" class="clearfix">
                            <span>建筑数据</span>
                        </div>
                        <!--<el-form label-suffix=":" label-position="left">-->

                            <!--<el-form-item label="">-->
                                <!--<el-button type="primary">查询</el-button>-->
                            <!--</el-form-item>-->
                        <!--</el-form>-->
                    </el-card>

                    <el-table :data="mainCitys">
                        <el-table-column prop="id" label="id" width="60px"></el-table-column>
                        <el-table-column label="建筑名">
                            <template slot-scope="scope">
                                <span v-for="item in mainCityOptions" v-if="item.id == scope.row.id">{{item.name}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="图标">
                            <template slot-scope="scope">
                                <el-image style="width: 60px; height: 60px"
                                          :src="'./static/main_city_icon/'+scope.row.id+'.png'"
                                          fit="cover">
                                    <div slot="error" class="image-slot">
                                        <el-image style="width: 60px; height: 60px"
                                                  :src="'./static/item_icon/0.png'"
                                                  fit="cover">
                                        </el-image>
                                    </div>
                                </el-image>
                            </template>
                        </el-table-column>
                        <el-table-column prop="level" label="等级"></el-table-column>
                        <el-table-column prop="finishTime" label="升级的完成时间"></el-table-column>
                    </el-table>
                </el-tab-pane>
            </el-tabs>
        </el-dialog>

        <el-dialog :title="blockAndForbidType =='block'?'封号':blockAndForbidType =='forbid'?'禁言':blockAndForbidType =='fakeForbid'?'伪禁言':''"
                   :visible.sync="blockAndForbidDialog" width="50%" lock-scroll center>
            <el-form label-suffix=":" label-width="100px">
                <el-form-item label="时长">
                    <!--<el-input-number v-model="blockAndForbidForm.time" @change="handleTimeChange" :min="-1"></el-input-number>-->
                    <!--分钟-->
                    <!--<span class="time-tip">(-1为永久)</span>-->

                    <el-select v-model="blockAndForbidForm.time" filterable clearable default-first-option @change="handleTimeChange">
                        <el-option v-for="item in blockAndForbidTimeOptions" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="提示">
                    <el-input v-model="blockAndForbidForm.prompt" placeholder='' ></el-input>
                </el-form-item>
                <el-form-item label="内部操作原因">
                    <el-autocomplete
                        class="inline-input"
                        type="textarea"
                        :maxlength="300"
                        show-word-limit
                        :autosize="{ minRows: 2}"
                        v-model="blockAndForbidForm.reason"
                        :fetch-suggestions="querySearchrRasonTemplate"
                        placeholder="请输入内容"
                        @select="handleSelectBlockAndForbid"
                    >
                        <template slot-scope="{ item }">
                            <span class="addr">{{item.reason}}</span>
                        </template>
                    </el-autocomplete>
                </el-form-item>
                <!--<el-form-item label="言论标签">-->
                    <!--<div class="opinion-tag">-->
                        <!--<el-autocomplete-->
                            <!--class="inline-input"-->
                            <!--type="textarea"-->
                            <!--:maxlength="20"-->
                            <!--show-word-limit-->
                            <!--:autosize="{ minRows: 2}"-->
                            <!--v-model="blockAndForbidForm.chatLabelLv1"-->
                            <!--:fetch-suggestions="querySearchOpinionTagLv1"-->
                            <!--placeholder="请输入一级标签"-->
                            <!--@select="handleSelectOpinionTagLv1BlockAndForbid"-->
                        <!--&gt;-->
                            <!--<template slot-scope="{ item }">-->
                                <!--<span class="addr">{{item.reason}}</span>-->
                            <!--</template>-->
                        <!--</el-autocomplete>-->
                        <!--<el-autocomplete-->
                            <!--class="inline-input"-->
                            <!--type="textarea"-->
                            <!--:maxlength="20"-->
                            <!--show-word-limit-->
                            <!--:autosize="{ minRows: 2}"-->
                            <!--v-model="blockAndForbidForm.chatLabelLv2"-->
                            <!--:fetch-suggestions="querySearchOpinionTagLv2"-->
                            <!--placeholder="请输入二级标签"-->
                            <!--@select="handleSelectOpinionTagLv2BlockAndForbid"-->
                        <!--&gt;-->
                            <!--<template slot-scope="{ item }">-->
                                <!--<span class="addr">{{item.reason}}</span>-->
                            <!--</template>-->
                        <!--</el-autocomplete>-->
                    <!--</div>-->

                <!--</el-form-item>-->
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="blockAndForbidDialog = false">取消</el-button>
                <el-button type="primary" @click="blockAndForbid">确认</el-button>
            </div>
        </el-dialog>

        <el-dialog :title="removeBanType=='block'?'解除封号':removeBanType=='forbid'?'解除(禁言\伪禁言)':''" :visible.sync="removeBanDialog" width="50%" lock-scroll center>
            <el-form label-suffix=":" label-width="100px">
                <el-form-item label="内部操作原因">
                    <el-autocomplete
                        class="inline-input"
                        type="textarea"
                        :maxlength="300"
                        show-word-limit
                        :autosize="{ minRows: 2}"
                        v-model="removeBlockForm.reason"
                        :fetch-suggestions="querySearchrRasonTemplate"
                        placeholder="请输入内容"
                        @select="handleSelectRemoveBlockAndForbid"
                    >
                        <template slot-scope="{ item }">
                            <span class="addr">{{item.reason}}</span>
                        </template>
                    </el-autocomplete>
                </el-form-item>
                <!--<el-form-item label="言论标签">-->
                    <!--<el-autocomplete-->
                        <!--class="inline-input"-->
                        <!--type="textarea"-->
                        <!--:maxlength="20"-->
                        <!--show-word-limit-->
                        <!--:autosize="{ minRows: 2}"-->
                        <!--v-model="removeBlockForm.chatLabel"-->
                        <!--:fetch-suggestions="querySearchOpinionTagLv1"-->
                        <!--placeholder="请输入一级标签"-->
                        <!--@select="handleSelectOpinionTagRemoveBlockAndForbid"-->
                    <!--&gt;-->
                        <!--<template slot-scope="{ item }">-->
                            <!--<span class="addr">{{item.reason}}</span>-->
                        <!--</template>-->
                    <!--</el-autocomplete>-->
                <!--</el-form-item>-->
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="removeBanDialog = false">取消</el-button>
                <el-button type="primary" @click="removeBlockAndForbid">确认</el-button>
            </div>
        </el-dialog>

        <el-dialog title="改名" :visible.sync="renameDialog" width="50%" lock-scroll center>
            <el-form label-suffix=":" label-width="100px">
                <el-form-item label="新名字">
                    <el-input v-model="renameForm.newName" placeholder=''></el-input>
                </el-form-item>
                <el-form-item label="内部操作原因">
                    <el-autocomplete
                        class="inline-input"
                        type="textarea"
                        :maxlength="300"
                        show-word-limit
                        :autosize="{ minRows: 2}"
                        v-model="renameForm.reason"
                        :fetch-suggestions="querySearchrRasonTemplate"
                        placeholder="请输入内容"
                        @select="handleSelectRename"
                    >
                        <template slot-scope="{ item }">
                            <span class="addr">{{item.reason}}</span>
                        </template>
                    </el-autocomplete>
                </el-form-item>
                <el-form-item label="言论标签">
                    <div class="opinion-tag">
                        <el-autocomplete
                            class="inline-input"
                            type="textarea"
                            :maxlength="20"
                            show-word-limit
                            :autosize="{ minRows: 2}"
                            v-model="renameForm.chatLabelLv1"
                            :fetch-suggestions="querySearchOpinionTagLv1"
                            placeholder="请输入一级标签"
                            @select="handleSelectOpinionTagLv1Rename"
                        >
                            <template slot-scope="{ item }">
                                <span class="addr">{{item.reason}}</span>
                            </template>
                        </el-autocomplete>

                        <el-autocomplete
                            class="inline-input"
                            type="textarea"
                            :maxlength="20"
                            show-word-limit
                            :autosize="{ minRows: 2}"
                            v-model="renameForm.chatLabelLv2"
                            :fetch-suggestions="querySearchOpinionTagLv2"
                            placeholder="请输入二级标签"
                            @select="handleSelectOpinionTagLv2Rename"
                        >
                            <template slot-scope="{ item }">
                                <span class="addr">{{item.reason}}</span>
                            </template>
                        </el-autocomplete>
                    </div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="renameDialog = false">取消</el-button>
                <el-button type="primary" @click="playerRename">确认</el-button>
            </div>
        </el-dialog>

        <el-dialog title="道具扣减" :visible.sync="deductItemDialog" width="50%" lock-scroll center>
            <el-form label-suffix=":" label-width="100px">
                <el-form-item label="选择道具" >
                    <el-select v-model="deductItemForm.propId" filterable placeholder='请选择道具'>
                        <el-option v-for="item in propConfigs" :key="item.id" v-if="item.big_type !== 4 &&item.big_type !== 5 &&item.big_type !== 7 &&item.big_type !== 14 && item.big_type !== 16"
                                   :label="item.id+'-'+$t(item.name)" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="数量" >
                <el-input-number v-model="deductItemForm.amount"></el-input-number>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="deductItemDialog = false">取消</el-button>
                <el-button type="primary" @click="deductItemConfirm">确认</el-button>
            </div>
        </el-dialog>
    </el-card>
</template>

<script>
    import gameApi from '../../service/game_api'
    import configSettingApi from '../../service/config_setting_api'
    import skin_type from '../../data/config/skin_type.json';
    import emblem_quality from '../../data/config/emblem_quality.json';
    import lineup_no_json from '../../data/config/lineup_no.json';
    import war_groove_quality from '../../data/config/war_groove_quality'


    import {
        mapState
    } from 'vuex';
    import actionConfirm from '../../mixins/action_confirm'
    import commonApi from '../../service/common_api';
    import componentQuery from '../../components/component_query'
    import componentServer from '../../components/component_server'
    import Utils from '../../lib/utils'

    export default {
        data() {
            return {
                globalConfig: Global_Config,
                Utils: Utils,
                activeName:"basic",
                playerQueryMode: ['mode_long_id','mode_short_id','mode_nick','mode_email'],
                previewDateShow: false,
                monsterConfigs: [],
                propConfigs:[],
                emblemEffectConfigs:[],
                emblemEffectConfigMap:{},
                godConfigs:[],
                warGrooveConfigs:[],
                skinConfigs:[],
                dateTime: '',

                queryForm: {
                    id: '',
                    email: '',
                    nick: ''
                },
                players: [],
                player: {
                    user: {
                        id: -1,
                    },
                },
                monsterQueryForm: {
                    identifier: "",
                    lv1: 1,
                    lv2: 90,
                },
                skinQueryForm:{
                    type:"",
                    identifier: "",
                },
                emblemQueryForm:{
                    quality:"",
                    lv1: 1,
                    lv2: 90,
                    syncLv:"",
                    stage:""
                },
                warGrooveQueryForm : {
                    quality: ''
                },
                propQueryForm: {
                    identifier: "",
                    type: '0'
                },

                monsters:[],
                selectMonsterData:[],
                selectedMonsterConditionData:[],
                monsterConditions: '',

                emblems:[],
                selectEmblemData:[],
                selectedEmblemConditionData:[],
                emblemConditions: '',


                lineups:[],
                lineupNo:1,

                warGrooves:[],
                selectWarGrooveData:[],
                selectedWarGrooveConditionData:[],
                warGrooveConditions: '',

                props:[],
                selectPropData: [],
                selectedPropConditionData: [],
                propConditions: [],

                mainCitys:[],

                monsterShow: {},
                lineupNoType:lineup_no_json,
                skinType:skin_type,
                emblemQuality:emblem_quality,
                warGrooveQuality: war_groove_quality,
                emblemQualityMap:{},
                warGrooveQualityMap:{},

                propOptionMap:{
                    '0':this.$t("reward_editor.39"),
                    '1':this.$t("reward_editor.40"),
                    '2':this.$t("reward_editor.41"),
                    '3':this.$t("reward_editor.42"),
                    '4':this.$t("reward_editor.43"),
                    '5':'约束性道具',
                    '6':this.$t("reward_editor.44"),
                    '7':'战纹',
                    '8':this.$t("reward_editor.46"),
                    '9':this.$t("reward_editor.47"),
                    '10':'回复类道具',
                    '11':'头像',
                    '12':'头像框',
                    '13':'宝箱',
                    '14':'皮肤',
                    '15':'时效类道具',
                },

                allPropData: [],

                blockAndForbidType: '',
                blockAndForbidDialog: false,
                blockAndForbidForm: {
                    reason: '',
                    prompt: '',
                    time: '',
                    chatLabelLv1: '',
                    chatLabelLv2: ''
                },
                removeBanType: '',
                removeBanDialog: false,
                removeBlockForm: {
                    reason: '',
                    // chatLabel: ''
                },
                renameDialog: false,
                renameForm: {
                    newName: '',
                    reason: '',
                    chatLabelLv1: '',
                    chatLabelLv2: '',
                },
                playerData: {},

                // 原因模板数据
                reasonTemplateData: [],

                // 言论标签数据
                opinionTagData: [],
                opinionTagDataLv1: [],
                opinionTagDataLv2: [],

                mainCityOptions: [
                    {
                        id: 1,
                        name: '领地'
                    },
                    {
                        id: 2,
                        name: '骨场'
                    },
                    {
                        id: 3,
                        name: '木场'
                    },
                    {
                        id: 4,
                        name: '鳞场'
                    },
                    {
                        id: 5,
                        name: '仓库'
                    },
                    {
                        id: 6,
                        name: '探索营地'
                    },
                    {
                        id: 7,
                        name: '起源基石'
                    },
                    {
                        id: 8,
                        name: '一发入魂商店'
                    },
                    {
                        id: 9,
                        name: '斗技场'
                    },
                    {
                        id: 10,
                        name: '黑暗森林'
                    },
                    {
                        id: 11,
                        name: '迷之巢穴'
                    },
                    {
                        id: 12,
                        name: '起源殿'
                    },
                    {
                        id: 13,
                        name: '战墙'
                    },
                    {
                        id: 14,
                        name: '学舌鸦'
                    },
                    {
                        id: 15,
                        name: '造物台'
                    },
                    {
                        id: 16,
                        name: '祭坛'
                    },
                    {
                        id: 17,
                        name: '永生之茧'
                    },
                    {
                        id: 18,
                        name: '凿星裂痕'
                    },
                    {
                        id: 19,
                        name: '部落营地'
                    }
                ],

                clearPlayerNameShow: false,
                clearPlayerNameForm: {},


                deductItemDialog :false,
                deductItemForm:{},

                copyInfo: '',

                blockAndForbidTimeOptions: [
                    {
                        label: '永久',
                        value: -1
                    },
                    {
                        label: '1小时',
                        value: 60
                    },
                    {
                        label: '3小时',
                        value: 180
                    },
                    {
                        label: '12小时',
                        value: 720
                    },
                    {
                        label: '1天',
                        value: 1440
                    },
                    {
                        label: '3天',
                        value: 4320
                    },
                    {
                        label: '7天',
                        value: 10080
                    },
                    {
                        label: '14日',
                        value: 20160
                    },
                    {
                        label: '30日',
                        value: 43200
                    },
                ]
            }
        },
        mixins: [actionConfirm],
        mounted() {
            this.getConfigs();
            this.getReasonListAll();
            this.getOpinionTagListAll();
        },
        created() {
            this.emblemQuality.forEach(item=>{
                this.emblemQualityMap[item.id] = item.val;
            })
            this.warGrooveQuality.forEach(item=>{
                this.warGrooveQualityMap[item.id] = item.val;
            })

        },
        computed: {
            ...mapState({
                token: state => state.user.userInfo.loginToken,
                serverGameList: state => state.server.serverGameList,
            }),
        },
        methods: {
            getGameValue(val) {
                console.log("获取服务器选择",val)
            },
            /**
             * 查询用户数据
             */
            getUsersData(val) {
                this.players = val;
            },
            showUserDetail(player) {
                this.showUserDetailAxios(player);
                this.previewDateShow = true;
                this.activeName = 'basic';
            },
            /**
             * 查询用户详情
             */
            showUserDetailAxios(player) {
                let self = this;
                gameApi.playerDetail({
                    playerQueryForm: {
                        uri: player.uri,
                        serverId: player.server,
                        userId: player.id,
                        email: '',
                        nick: ''
                    },
                    token: this.token
                }).then(res => {
                    self.player = res.content.detail
                    self.player.uri = player.uri;
                    self.player.server = player.server;
                    self.player.id = player.id;
                    let time = self.player.user.loginModified;
                    let newDate = new Date();
                    if (time) {
                        newDate.setTime(time);
                        self.player.user.loginModified = newDate.toLocaleString();
                    }

                    time = self.player.user.buyEnergyModified
                    if (time) {
                        newDate = new Date();
                        newDate.setTime(time);
                        self.player.user.buyEnergyModified = newDate.toLocaleString();
                    }

                    time = self.player.user.energyModified
                    if (time) {
                        newDate = new Date();
                        newDate.setTime(time);
                        self.player.user.energyModified = newDate.toLocaleString();
                    }
                })
            },

            getPlayerMonsters() {
                let self = this;
                gameApi.findMonstersByPlayerId({
                    playerQueryForm: {
                        uri: self.player.uri,
                        serverId: self.player.server,
                        userId: self.player.id,
                        email: '',
                        nick: ''
                    },
                    token: this.token
                }).then(res => {
                    self.monsters = res.content.monsters;
                })
            },

            getPlayerEmblems() {
                let self = this;
                gameApi.findEmblemsByPlayerId({
                    playerQueryForm: {
                        uri: self.player.uri,
                        serverId: self.player.server,
                        userId: self.player.id,
                        email: '',
                        nick: ''
                    },
                    token: this.token
                }).then(res => {
                    self.emblems = res.content.emblems;
                    self.emblems.forEach(emblemItem =>{
                        emblemItem.properties.forEach(property=>{
                            if(property.type === 0){
                                emblemItem.baseType = property.effectId;
                            }
                        })
                    })
                    console.log(self.emblems);
                })
            },

            getPlayerLineups() {
                let self = this;
                gameApi.findLineupsByPlayerId({
                    playerQueryForm: {
                        uri: self.player.uri,
                        serverId: self.player.server,
                        userId: self.player.id,
                        email: '',
                        nick: ''
                    },
                    token: this.token
                }).then(res => {
                    self.lineups = res.content.lineups;
                    console.log(self.lineups);
                })
            },

            getPlayerWarGroove() {
                let self = this;
                gameApi.findWarGroovesByPlayerId({
                    playerQueryForm: {
                        uri: self.player.uri,
                        serverId: self.player.server,
                        userId: self.player.id,
                        email: '',
                        nick: ''
                    },
                    token: this.token
                }).then(res => {
                    var warGrooves = [];
                    res.content.warGrooves.forEach(item => {
                        var temp = item.id.split('_');
                        warGrooves.push({
                            id: item.id,
                            identifier: temp[1],
                            quality: temp[2],
                            pipeline: temp[0]
                        })
                    })

                    self.warGrooves = warGrooves;
                    console.log(self.warGrooves);
                })
            },

            getPlayerProps() {
                let self = this;
                gameApi.findPropsByPlayerId({
                    playerQueryForm: {
                        uri: self.player.uri,
                        serverId: self.player.server,
                        userId: self.player.id,
                        email: '',
                        nick: ''
                    },
                    token: this.token
                }).then(res => {
                    self.props = res.content.props;
                    console.log(self.props);
                })
            },

            getPlayerSkins() {
                let self = this;
                gameApi.findSkinsByPlayerId({
                    playerQueryForm: {
                        uri: self.player.uri,
                        serverId: self.player.server,
                        userId: self.player.id,
                        email: '',
                        nick: ''
                    },
                    token: this.token
                }).then(res => {
                })
            },

            handleClick(tab, event) {
                let self = this;
                if(tab.name =='monsters'){
                    // self.getPlayerMonsters();
                    self.selectMonsters();
                }else if(tab.name =='emblems'){
                    // self.getPlayerEmblems();
                    self.selectEmblems();
                }else if(tab.name =='warGroove'){
                    // self.getPlayerWarGroove();
                    self.selectWarGroove();
                }else if(tab.name =='props'){
                    // self.getPlayerProps();
                    self.selectProp();
                }else if(tab.name =='skins'){
                    self.getPlayerSkins();
                }else if(tab.name =='lineups'){
                    self.getPlayerLineups();
                } else if(tab.name =='mainCity'){
                    gameApi.findMainCityByPlayerId({
                        playerQueryForm: {
                            uri: self.player.uri,
                            serverId: self.player.server,
                            userId: self.player.id,
                            email: '',
                            nick: ''
                        },
                        token: this.token
                    }).then(res => {
                        self.mainCitys = res.content.mainCitys;
                        console.log(self.mainCitys);
                    })
                }

            },

            getConfigs() {
                let self = this;
                let tables = 'monster_config,monster_temperament_config,emblem_effect_config,' +
                    'war_groove_config,skin_config,god_config,prop_config';
                commonApi.getConfs({
                    tables: tables
                }).then(res => {
                    self.monsterConfigs = res.monster_config;
                    self.propConfigs = res.prop_config;
                    self.emblemEffectConfigs = res.emblem_effect_config;
                    self.emblemEffectConfigs.forEach(item=>{
                        self.emblemEffectConfigMap[item.id] = item;
                    })

                    self.godConfigs = res.god_config;
                    self.warGrooveConfigs = res.war_groove_config;
                    self.skinConfigs = res.skin_config;

                    self.propConfigs.forEach(item => {
                        self.allPropData.push({
                            id: item.id,
                            name: self.$t(item.name)
                        })
                    })

                    self.monsterConfigs.forEach(item => {
                        self.allPropData.push({
                            id: item.id + 10000,
                            name: self.$t(item.name) + self.$t('reward_editor.4')
                        })

                        let monsterRace = item.race;
                        let monsterQuality = item.quality;
                        if (monsterQuality === 4 && monsterRace.indexOf("_") > -1) {
                            self.allPropData.push({
                                id: item.id + 20000,
                                name: self.$t(item.name) + self.$t('reward_editor.17')
                            });
                            self.allPropData.push({
                                id: item.id + 30000,
                                name: self.$t(item.name) + self.$t('reward_editor.18')
                            });

                            self.allPropData.push({
                                id: item.id + 70000,
                                name: self.$t(item.name) + "的进化光谱"
                            });

                            self.propConfigs.push({
                                id: item.id + 70000,
                                name: self.$t(item.name) + "的进化光谱",
                                big_type: 19
                            })
                        }
                    })
                })

            },
            /**
             * 禁言
             */
            banTalk(id) {

            },
            /**
             * 封号
             */
            banAccount(id) {

            },

            formatterTime(row) {
                var gmtCreate = row.gmtCreate;
                gmtCreate = Utils.formatDate(gmtCreate);
                return gmtCreate;
            },

            // 筛选怪兽
            selectMonsters() {
                this.getPlayerMonsters();
                setTimeout(() => {
                    var identifier = this.monsterQueryForm.identifier;
                    var lv1 = this.monsterQueryForm.lv1;
                    var lv2 = this.monsterQueryForm.lv2;
                    var dateTime = this.dateTime;

                    if (dateTime == null) {
                        dateTime = '';
                    }
                    var dateTime1 = dateTime!==''?new Date(dateTime[0]).getTime():'';
                    var dateTime2 = dateTime!==''?new Date(dateTime[1]).getTime():'';
                    var monsters = this.monsters;
                    var _monsters = [];
                    monsters.forEach(item => {
                        if (identifier !== '' && dateTime !== '') {
                            if ((item.identifier == identifier) && (item.level >= lv1 && item.level <= lv2) && (item.gmtCreate >= dateTime1 && item.gmtCreate <= dateTime2)) {
                                _monsters.push(item)
                            }
                        } else if (identifier !== '' && dateTime == '') {
                            if ((item.identifier == identifier) && (item.level >= lv1 && item.level <= lv2)) {
                                _monsters.push(item)
                            }
                        } else if (identifier == '' && dateTime !== '') {
                            if ((item.level >= lv1 && item.level <= lv2) && (item.gmtCreate >= dateTime1 && item.gmtCreate <= dateTime2)) {
                                _monsters.push(item)
                            }
                        } else if (identifier == '' && dateTime == '') {
                            if ((item.level >= lv1 && item.level <= lv2)) {
                                _monsters.push(item)
                            }
                        }

                    })
                    this.selectMonsterData = _monsters;

                    if (this.selectMonsterData.length > 0) {
                        if (this.selectedMonsterConditionData.length >= 5) {
                            this.selectedMonsterConditionData.splice(0,1)
                        }
                        this.selectedMonsterConditionData.push({
                            identifier: identifier,
                            lv1: lv1,
                            lv2: lv2,
                            dateTime1: dateTime?dateTime[0]:'',
                            dateTime2: dateTime?dateTime[1]:''
                        })
                    }
                },1000)
            },

            // 筛选元核-元核
            selectEmblems() {
                this.getPlayerEmblems();
                setTimeout(() => {
                    var quality = this.emblemQueryForm.quality;
                    var lv1 = this.emblemQueryForm.lv1;
                    var lv2 = this.emblemQueryForm.lv2;
                    var emblems = this.emblems;
                    var _emblems = [];
                    emblems.forEach(item => {
                        if (quality !== '') {
                            if ((quality == item.quality) && (item.level >= lv1 && item.level <= lv2)) {
                                _emblems.push(item)
                            }
                        } else {
                            if ((item.level >= lv1 && item.level <= lv2)) {
                                _emblems.push(item)
                            }
                        }
                    })

                    this.selectEmblemData = _emblems;

                    if (this.selectEmblemData.length > 0) {
                        if (this.selectedEmblemConditionData.length >= 5) {
                            this.selectedEmblemConditionData.splice(0,1)
                        }
                        this.selectedEmblemConditionData.push({
                            quality: quality,
                            lv1: lv1,
                            lv2: lv2
                        })
                    }
                },1000)
            },

            // 筛选阵容
            selectLineups() {
                this.getPlayerLineups();
                setTimeout(() => {
                    var lineups = this.lineups;
                    var lineupNo = this.lineupNo;
                    var _lineups = [];
                    lineups.forEach(item => {
                        if (lineupNo == item.lineupNo) {
                            _lineups.push(item)
                        }
                    })
                    this.lineups = _lineups;
                },1000)
            },

            // 筛选战纹
            selectWarGroove() {
                this.getPlayerWarGroove();
                setTimeout(() => {
                    var quality = this.warGrooveQueryForm.quality;
                    var warGrooves = this.warGrooves;
                    var _warGrooves = [];
                    warGrooves.forEach(item => {
                        if (quality == item.quality) {
                            _warGrooves.push(item)
                        }
                    })

                    this.selectWarGrooveData = _warGrooves;

                    if (this.selectWarGrooveData.length > 0) {
                        if (this.selectedWarGrooveConditionData.length >= 5) {
                            this.selectedWarGrooveConditionData.splice(0,1)
                        }
                        this.selectedWarGrooveConditionData.push({
                            quality: quality
                        })
                    }
                },1000)
            },

            // 筛选物品
            selectProp() {
                this.getPlayerProps();
                setTimeout(() => {
                    var identifier = this.propQueryForm.identifier;
                    var type = this.propQueryForm.type;
                    var props = this.props;
                    var _props = [];
                    props.forEach(item => {
                        if (type !== '' && identifier !== '') {
                            if ((type == item.type) && (identifier == item.identifier)) {
                                _props.push(item)
                            }
                        } else if (identifier !== '' && type == '') {
                            if (identifier == item.identifier) {
                                _props.push(item)
                            }
                        } else if (type !== '' && identifier == '') {
                            if (type == item.type) {
                                _props.push(item)
                            }
                        }
                    })

                    this.selectPropData = _props;

                    if (this.selectPropData.length > 0) {
                        if (this.selectedPropConditionData.length >= 5) {
                            this.selectedPropConditionData.splice(0,1)
                        }
                        this.selectedPropConditionData.push({
                            identifier: identifier,
                            type: type
                        })
                    }
                },1000)
            },

            findMonsterByConditions(e) {
                this.dateTime == '';
                var data = this.selectedMonsterConditionData[e];

                this.monsterQueryForm.identifier = data.identifier;
                this.monsterQueryForm.lv1 = data.lv1;
                this.monsterQueryForm.lv2 = data.lv2;
                if (data.dateTime1 == '' || data.dateTime2 == '') {
                    this.dateTime == '';
                } else {
                    this.dateTime = [data.dateTime1,data.dateTime2];
                }

                this.selectMonsters();
            },

            findEmblemByConditions(e) {
                var data = this.selectedEmblemConditionData[e];

                this.emblemQueryForm.quality = data.quality;
                this.emblemQueryForm.lv1 = data.lv1;
                this.emblemQueryForm.lv2 = data.lv2;

                this.selectEmblems();
            },

            findWarGrooveByConditions(e) {
                var data = this.selectedWarGrooveConditionData[e];

                this.warGrooveQueryForm.quality = data.quality;

                this.selectWarGroove();
            },

            findPropByConditions(e) {
                var data = this.selectedPropConditionData[e];

                this.propQueryForm.identifier = data.identifier;
                this.propQueryForm.type = data.type;

                this.selectProp();
            },

            blockAndForbidShow(type,data) {
                this.blockAndForbidType = type;
                this.playerData = data;
                this.blockAndForbidDialog = true;
                this.blockAndForbidForm = {
                    prompt : '',
                    time: '',
                    reason: '',
                    chatLabelLv1: '',
                    chatLabelLv2: ''
                };
            },

            removeBanShow(type,data) {
                this.removeBanType = type;
                this.playerData = data;
                this.removeBanDialog = true;
                this.removeBlockForm = {
                     reason: '',
                     // chatLabel: ''
                };
            },

            // 封号/禁言/伪禁言
            blockAndForbid() {
                var self = this;
                var data = this.blockAndForbidForm;
                var playData = this.playerData;
                console.log(data.time)

                if (data.prompt == '' || data.time == '' || data.reason == '') {
                    self.$message({
                        type: 'warning',
                        message: '请填写完所有选项!'
                    })
                    return;
                }

                var blockPrompt = '';
                var blockPromptConfirm = '';
                var forbidPrompt = '';
                var forbidPromptConfirm = '';
                var fakeForbidPrompt = '';
                var fakeForbidPromptConfirm = '';
                if (data.time !== -1) {
                    var finalDate = Utils.formatDate(new Date().getTime() + parseInt(data.time*60000));
                    // blockPrompt = data.prompt + " 解封时间为(" + finalDate + ')';
                    blockPromptConfirm = data.prompt + " 解封时间为(" + finalDate + ')';
                    blockPrompt = data.prompt;
                    // forbidPrompt = data.prompt + " 解禁时间为(" + finalDate + ')';
                    forbidPromptConfirm = data.prompt + " 解禁时间为(" + finalDate + ')';
                    forbidPrompt = data.prompt;
                    // fakeForbidPrompt = data.prompt + " 解禁时间为(" + finalDate + ')';
                    fakeForbidPromptConfirm = data.prompt + " 解禁时间为(" + finalDate + ')';
                    fakeForbidPrompt = data.prompt;
                } else {
                    blockPrompt = data.prompt;
                    forbidPrompt = data.prompt;
                    fakeForbidPrompt = data.prompt;
                }


                if (self.blockAndForbidType == 'block') {
                    this.$confirm(blockPromptConfirm, '最终提示', {
                        distinguishCancelAndClose: true,
                        confirmButtonText: '确定',
                        cancelButtonText: '取消'
                    }).then(() => {
                        gameApi.blockRole({
                            token: self.token,
                            blockRoleBO: {
                                prompt : blockPrompt,
                                time: data.time,
                                reason: data.reason,
                                chatLabel: data.chatLabelLv1 + '-' + data.chatLabelLv2,
                                gameUri: playData.uri,
                                gameServer: playData.server,
                                userId: playData.id
                            }
                        }).then(res => {
                            self.blockAndForbidDialog = false;
                            self.$message({
                                type: 'success',
                                message: '封停角色成功!'
                            })
                        })
                    }).catch(action => {

                    });
                } else if (self.blockAndForbidType == 'forbid') {
                    this.$confirm(forbidPromptConfirm, '最终提示', {
                        distinguishCancelAndClose: true,
                        confirmButtonText: '确定',
                        cancelButtonText: '取消'
                    }).then(() => {
                        gameApi.forbidSpeak({
                            token: self.token,
                            forbidSpeakBO: {
                                prompt : forbidPrompt,
                                time: data.time,
                                reason: data.reason,
                                chatLabel: data.chatLabelLv1 + '-' + data.chatLabelLv2,
                                gameUri: playData.uri,
                                gameServer: playData.server,
                                userId: playData.id
                            }
                        }).then(res => {
                            self.blockAndForbidDialog = false;
                            self.$message({
                                type: 'success',
                                message: '禁言成功!'
                            })
                        })
                    }).catch(action => {

                    });
                } else if (self.blockAndForbidType == 'fakeForbid') {
                    this.$confirm(fakeForbidPromptConfirm, '最终提示', {
                        distinguishCancelAndClose: true,
                        confirmButtonText: '确定',
                        cancelButtonText: '取消'
                    }).then(() => {
                        gameApi.fakeForbidSpeak({
                            token: self.token,
                            fakeForbidSpeakBO: {
                                prompt : fakeForbidPrompt,
                                time: data.time,
                                reason: data.reason,
                                chatLabel: data.chatLabelLv1 + '-' + data.chatLabelLv2,
                                gameUri: playData.uri,
                                gameServer: playData.server,
                                userId: playData.id
                            }
                        }).then(res => {
                            self.blockAndForbidDialog = false;
                            self.$message({
                                type: 'success',
                                message: '伪禁言成功!'
                            })
                        })
                    }).catch(action => {

                    });
                }
            },
            // 解除封号\禁言、伪禁言
            removeBlockAndForbid() {
                var self = this;
                var data = this.removeBlockForm;
                var playData = this.playerData;

                if (data.reason == '') {
                    self.$message({
                        type: 'warning',
                        message: '请填写原因!'
                    })
                    return;
                }

                if (self.removeBanType == 'block') {
                    gameApi.unblockRole({
                        token: self.token,
                        unblockRoleBO: {
                            reason: data.reason,
                            // chatLabel: data.chatLabel,
                            gameUri: playData.uri,
                            gameServer: playData.server,
                            userId: playData.id
                        }
                    }).then(res => {
                        self.removeBanDialog = false;
                        self.$message({
                            type: 'success',
                            message: '解封角色成功!'
                        })
                    })
                } else if (self.removeBanType == 'forbid') {
                    gameApi.allowSpeak({
                        token: self.token,
                        allowSpeakBO: {
                            reason: data.reason,
                            // chatLabel: data.chatLabel,
                            gameUri: playData.uri,
                            gameServer: playData.server,
                            userId: playData.id
                        }
                    }).then(res => {
                        self.removeBanDialog = false;
                        self.$message({
                            type: 'success',
                            message: '解禁成功!'
                        })
                    })
                }
            },

            renameShow(data) {
                this.playerData = data;
                this.renameDialog = true;
                var newName = '探索者' + data.userId.toString().slice(-6);
                this.renameForm = {
                    newName: newName,
                    reason: '',
                    chatLabelLv1: '',
                    chatLabelLv2: '',
                };
            },

            deductItemShow(rowData){
                this.playerData = rowData;
                this.deductItemDialog = true;
                this.deductItemForm = {
                    propId: '',
                    amount: 1,
                };
            },

            deductItemConfirm(){
                var self = this;
                var playData = this.playerData;
                if (self.deductItemForm.propId ==='' || self.deductItemForm.amount <= 0){
                    self.$message({
                        type: 'warning',
                        message: '参数异常!'
                    })
                    return;
                }
                gameApi.deductItem({
                    token: self.token,
                    deductItemForm: {
                        propId: self.deductItemForm.propId,
                        amount: self.deductItemForm.amount,
                        uri: playData.uri,
                        serverId: playData.server,
                        userId: playData.id
                    }
                }).then(res => {
                    self.renameDialog = false;
                    self.$message({
                        type: 'success',
                        message: '道具扣成功!'
                    })
                })
            },

            // 改名
            playerRename() {
                var self = this;
                var data = this.renameForm;
                var playData = this.playerData;

                if (data.newName == '' || data.reason == '') {
                    self.$message({
                        type: 'warning',
                        message: '请填写完所有选项!'
                    })
                    return;
                }

                gameApi.playerRename({
                    token: self.token,
                    renameBO: {
                        newName: data.newName,
                        reason: data.reason,
                        chatLabel: data.chatLabelLv1 + '-' + data.chatLabelLv2,
                        gameUri: playData.uri,
                        gameServer: playData.server,
                        userId: playData.id
                    }
                }).then(res => {
                    self.renameDialog = false;
                    self.$message({
                        type: 'success',
                        message: '改名成功!'
                    })
                })
            },

            // 解除关联
            playerDisconnect(playData) {
                var self = this;
                gameApi.playerDisconnect({
                    token: self.token,
                    disconnectBO: {
                        uri: playData.uri,
                        serverId: playData.server,
                        userId: playData.id
                    }
                }).then(res => {
                    self.$message({
                        type: 'success',
                        message: '解除关联成功!'
                    })
                })
            },

            // 屏蔽玩家信息
            playerInfoShield(playData,infoShield) {
                var self = this;
                gameApi.playerInfoShield({
                    token: self.token,
                    infoShieldBO: {
                        uri: playData.uri,
                        serverId: playData.server,
                        userId: playData.id,
                        infoShield: infoShield
                    }
                }).then(res => {
                    if (infoShield == '0') {
                        self.$message({
                            type: 'success',
                            message: '解除玩家屏蔽成功!'
                        })
                    } else {
                        self.$message({
                            type: 'success',
                            message: '屏蔽玩家信息成功!'
                        })
                    }

                })
            },

            // 模板列表查询
            getReasonListAll() {
                configSettingApi.reasonList({
                    token: this.token
                }).then(res => {
                    this.reasonTemplateData = res;
                })
            },

            querySearchrRasonTemplate(queryString, cb) {
                var data = this.reasonTemplateData;
                var results = queryString ? data.filter(this.createFilter(queryString)) : data;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },

            createFilter(queryString) {
                return (data) => {
                    return (data.reason.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            handleSelectBlockAndForbid(item) {
                this.blockAndForbidForm.reason = item.reason;
            },
            handleSelectRemoveBlockAndForbid(item) {
                this.removeBlockForm.reason = item.reason;
            },
            handleSelectRename(item) {
                this.renameForm.reason = item.reason;
            },

            handleTimeChange(time) {
                if (time == '-1') {
                    if (this.blockAndForbidType == 'block') {
                        this.blockAndForbidForm.prompt = '您的账号当前已被永久封停。'
                        this.blockAndForbidForm.reason = '默认原因为诈骗骚扰玩家类永封，若为其他重要原因请重新填写。'
                    } else if (this.blockAndForbidType == 'forbid') {
                        this.blockAndForbidForm.prompt = '您的角色当前已被永久禁言。'
                        this.blockAndForbidForm.reason = ''
                    } else if (this.blockAndForbidType == 'fakeForbid') {
                        this.blockAndForbidForm.prompt = '您的角色当前已被永久伪禁言。'
                        this.blockAndForbidForm.reason = ''
                    }
                } else {
                    if (this.blockAndForbidType == 'block') {
                        this.blockAndForbidForm.prompt = ''
                        this.blockAndForbidForm.reason = ''
                    } else if (this.blockAndForbidType == 'forbid') {
                        this.blockAndForbidForm.prompt = ''
                        this.blockAndForbidForm.reason = ''
                    } else if (this.blockAndForbidType == 'fakeForbid') {
                        this.blockAndForbidForm.prompt = '-'
                        this.blockAndForbidForm.reason = ''
                    }
                }
            },

            // 模板列表查询
            getOpinionTagListAll() {
                configSettingApi.opinionTagList({
                    token: this.token
                }).then(res => {
                    this.opinionTagData = res;
                    this.opinionTagData.forEach(item => {
                        if (item.level == 1) {
                            this.opinionTagDataLv1.push(item);
                        } else if (item.level == 2) {
                            this.opinionTagDataLv2.push(item);
                        }
                    })
                })
            },

            querySearchOpinionTagLv1(queryString, cb) {
                var data = this.opinionTagDataLv1;
                var results = queryString ? data.filter(this.createFilterOpinionTag(queryString)) : data;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },

            querySearchOpinionTagLv2(queryString, cb) {
                var data = this.opinionTagDataLv2;
                var results = queryString ? data.filter(this.createFilterOpinionTag(queryString)) : data;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },

            createFilterOpinionTag(queryString) {
                return (data) => {
                    return (data.reason.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            handleSelectOpinionTagLv1BlockAndForbid(item) {
                this.blockAndForbidForm.chatLabelLv1 = item.reason;
            },
            handleSelectOpinionTagLv2BlockAndForbid(item) {
                this.blockAndForbidForm.chatLabelLv2 = item.reason;
            },

            handleSelectOpinionTagRemoveBlockAndForbid(item) {
                this.removeBlockForm.chatLabel = item.reason;
            },

            handleSelectOpinionTagLv1Rename(item) {
                this.renameForm.chatLabelLv1 = item.reason;
            },
            handleSelectOpinionTagLv2Rename(item) {
                this.renameForm.chatLabelLv2 = item.reason;
            },

            handleCopyInfo(player) {
                var id = player.id;
                var nick = player.user.nick;
                var shortId = player.id.toString().slice(-6);
                var sid = player.user.email;
                var serverName = '';
                this.serverGameList.forEach(item => {
                    if (item.server_number == player.server) {
                        serverName = item.server_name;
                    }
                })

                this.copyInfo = '【长id】'+ id + '\n' +'【昵称】'+ nick + '\n' +'【短id】'+ shortId + '\n' +'【区服】'+ serverName + '\n' +'【sid】'+ sid;
            },
            onCopy(e) {
                this.$message({
                    type: 'success',
                    message: '已复制至系统粘贴板'
                });
            },
            onError(e) {
                this.$message({
                    type: 'error',
                    message: '复制失败,请手动复制'
                });
            },
        },
        components: {
            componentQuery,
            componentServer
        }
    };
</script>

<style lang="less">
    .el-card {
        margin: 1px 0 !important;
    }

    /* .demo-table-expand {
        font-size: 0;
    } */
    .player-form label {
        color: #99a9bf;
    }

    .demo-table-expand label {
        color: #99a9bf;
    }

    /* .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    } */

    .data-btn-group {
        margin-bottom: 10px;
    }

    .inline-input {
        width: 400px;
    }

    .time-tip {
        color: red;
    }

    .opinion-tag {
        display: flex;
        justify-content: space-between;
    }

    .player-btn {
        margin-bottom: 5px;
    }

    .charged-points {
        color: #99a9bf;
    }
</style>



// WEBPACK FOOTER //
// src/views/players/query_players.vue